module.exports = __webpack_public_path__ + "img/icon-succes-reserve-quote.bff85f37.svg";